import React from 'react'

import AIPoweredHero from "./section/AIPoweredHero.js"
import AICapabilities from './section/AICapabilities.js'
const AIPowered = () => {
  return (
    <>
   <AIPoweredHero/> 
   <AICapabilities/>
   </>
  )
}

export default AIPowered